import { useCallback, useState } from "react";

/**
|--------------------------------------------------
| 数値型パラメータの初期化
| 
| ★使用例
|   const [input, updateInput, resetInput] = useInitNumber();
|--------------------------------------------------
*/
export function useInitNumber(
    initialValue?: number
): [number, (value: number) => void, () => void] {
    const [value, setValue] = useState<number>(initialValue || 0);

    const handleInputChange = useCallback((target) => setValue(target), []);

    const reset = useCallback(() => setValue(0), []);

    return [value, handleInputChange, reset];
}
